module.exports = __webpack_public_path__ + "static/img/race2020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/race2020.jpg
// module id = 7aek
// module chunks = 0